export default "https://legacy.eskolare-development.com/images/forbidden.png";